import axios from 'axios'

const normalizeUrl = (url: string, tag: string, lang: string) => {
  const baseUrl = (process.env.VUE_APP_API || '').replace(/\/+$/, '')
  const path = `${url || ''}/${tag || ''}/${lang || ''}`.replace(/\/+$/, '')
  return `${baseUrl}/${path.replace(/^\/+/, '')}`
}

export default {
  get(url: string, tag: string, lang: string) {
    const requestUrl = normalizeUrl(url, tag, lang)
    const result = axios.get(
      requestUrl,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('userToken')
        }
      }
    )
    return result
  },

  post(url: string, tag: string, lang: string, body: unknown) {
    const requestUrl = normalizeUrl(url, tag, lang)
    const result = axios.post(
      requestUrl,
      body,
      {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        }
      }
    )
    return result
  },

  put(url: string, tag: string, lang: string, body: unknown) {
    const requestUrl = normalizeUrl(url, tag, lang)
    const result = axios.put(
      requestUrl,
      body,
      {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        }
      }
    )
    return result
  },

  delete(url: string, tag: string, lang: string, body: unknown) {
    const requestUrl = normalizeUrl(url, tag, lang)
    const result = axios.delete(
      requestUrl,
      {
        data: body,
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        }
      }
    )
    return result
  },

  downloadFile(url: string, tag: string, lang: string) {
    const requestUrl = normalizeUrl(url, tag, lang)
    const result = axios.get(
      requestUrl,
      {
        responseType: 'arraybuffer',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('userToken'),
          Accept: 'application/octet-stream'
        }
      }
    )
    return result
  },

  authentication(url: string, body: unknown) {
    const auxUrl = url
    const result = axios.post(
      process.env.VUE_APP_API + auxUrl.replace('//', '/'),
      body,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
    return result
  }
}
